import React from 'react';
import { Path, Svg } from '@react-pdf/renderer';

export const ZipCodeSvgAlt = ({
  width = 153,
  height = 151,
  scale = 1.0,
  color = '#000',
}): JSX.Element => {
  return (
    // @ts-expect-error - Svg props throws unnecessary TS Error but renders element
    // Known bug: https://github.com/diegomura/react-pdf/issues/1873 
    <Svg width={width * scale} height={height * scale}>
      <Path 
        stroke={ color }
        strokeWidth={0.5}
        style={{
          transform: `scale(${scale})`
        }}
        d="M76.5,97.59c0,74.11,0,68.85,0-1.19c0,70.04,0,64.79,0-1.19c0,65.98,0,60.73,0-1.19c0,61.92,0,56.67,0-1.19
        c0,57.86,0,63.12,0,1.19c0,61.92,0,67.18,0,1.19c0,65.98,0,71.24,0,1.19C76.5,166.44,76.5,171.69,76.5,97.59c0,74.11,0,68.85,0-1.19
        c0,70.04,0,64.79,0-1.19c0,65.98,0,60.73,0-1.19c0,61.92,0,56.67,0-1.19v1.19c0,61.92,0,67.18,0,1.19c0,65.98,0,71.24,0,1.19
        C76.5,166.44,76.5,171.69,76.5,97.59c0,74.11,0,68.85,0-1.19c0,70.04,0,64.79,0-1.19c0,65.98,0,60.73,0-1.19c0,61.92,0,56.67,0-1.19
        c0,57.86-7.97,61.18-1.81,0.75c-6.16,60.43-12.99,65.88-1.55,1.24c-11.44,64.65-18.34,70.01-1.57,1.22
        c-16.78,68.79-24.97,71-1.86,0.5c-23.11,70.5-28.55,64.03-1.23-1.47c-27.32,65.5-29.77,57.15-0.56-1.9
        c-29.21,59.04-31.44,50.63-0.51-1.91c-30.94,52.54-35.3,45.14-0.99-1.68c-34.31,46.82-42.74,44.95-1.91-0.43
        c-40.83,45.37-49.59,45.84-1.99,0.11c-47.6,45.74-56.37,46.02-1.99,0.06c-54.38,45.95-62.28,42.86-1.79-0.7
        c-60.49,43.57-60.98,35.17-0.11-1.91c-60.87,37.07-57.89,28.9,0.68-1.85c-58.56,30.76-55.42,22.64,0.71-1.84
        c-56.14,24.48-55.36,15.95,0.18-1.94C4.65,98.97-1.13,92.6,58.88,79.63c-60.01,12.97-67.4,8.28-1.68-1.06
        c-65.72,9.34-72.96,4.43-1.64-1.12c-71.32,5.54-75.78-1.63-1.01-1.63h1.2h1.2h1.2h1.2h-1.2h-1.2h-1.2h-1.2h1.2h1.2h1.2h1.2h-1.2
        h-1.2h-1.2h-1.2h1.2h1.2h1.2c-62.48,0-57.18,0,1.2,0c-58.38,0-61.73-7.9-0.76-1.79c-60.97-6.11-66.47-12.88-1.25-1.54
        c-65.22-11.34-70.64-18.18-1.23-1.55c-69.41-16.63-71.63-24.75-0.5-1.84c-71.13-22.9-64.6-28.3,1.48-1.22
        c-66.08-27.07-57.66-29.5,1.91-0.55c-59.57-28.95-51.08-31.17,1.93-0.5c-53.01-30.66-45.55-34.99,1.69-0.98
        c-47.24-34.01-45.35-42.37,0.43-1.9c-45.78-40.47-46.25-49.15-0.11-1.97C16.8,14.79,16.52,6.1,62.89,60
        C16.52,6.1,19.64-1.73,63.59,58.22C19.64-1.73,28.11-2.22,65.52,58.11c-37.4-60.33-29.16-57.37,1.87,0.67
        C36.36,0.74,44.55,3.85,69.25,59.49c-24.7-55.64-16.1-54.87,1.95,0.17c-18.05-55.05-11.62-60.77,1.46-1.3
        c-13.08-59.47-8.35-66.8,1.07-1.66c-9.42-65.14-4.47-72.31,1.12-1.63c-5.59-70.68,1.64-75.11,1.64-1c0-74.11,0-68.85,0,1.19
        c0-70.04,0-64.79,0,1.19c0-65.99,0-60.73,0,1.19c0-61.92,0-56.67,0,1.19c0-57.86,0-63.11,0-1.19c0-61.92,0-67.18,0-1.19
        c0-65.99,0-71.24,0-1.19c0-70.04,0-75.3,0-1.19c0-74.11,0-68.85,0,1.19c0-70.04,0-64.79,0,1.19c0-65.99,0-60.73,0,1.19
        c0-61.92,0-56.67,0,1.19v-1.19c0-61.92,0-67.18,0-1.19c0-65.99,0-71.24,0-1.19c0-70.04,0-75.3,0-1.19c0-74.11,0-68.85,0,1.19
        c0-70.04,0-64.79,0,1.19c0-65.99,0-60.73,0,1.19c0-61.92,0-56.67,0,1.19c0-57.86,7.97-61.18,1.81-0.75
        C84.47-2.35,91.3-7.8,79.86,56.84C91.3-7.8,98.2-13.17,81.43,55.62c16.78-68.79,24.97-71,1.86-0.5c23.11-70.5,28.55-64.03,1.23,1.47
        c27.32-65.5,29.77-57.15,0.56,1.9c29.21-59.04,31.44-50.63,0.51,1.91c30.94-52.54,35.3-45.14,0.99,1.68
        c34.31-46.82,42.75-44.95,1.91,0.42c40.83-45.37,49.59-45.84,1.99-0.11c47.6-45.74,56.37-46.01,1.99-0.06
        c54.38-45.95,62.28-42.86,1.79,0.7c60.49-43.57,60.98-35.17,0.11,1.91c60.87-37.07,57.89-28.9-0.68,1.85
        c58.56-30.76,55.42-22.64-0.71,1.84c56.14-24.48,55.37-15.95-0.18,1.94c55.54-17.89,61.32-11.52,1.31,1.45
        c60.01-12.97,67.4-8.28,1.68,1.06c65.72-9.34,72.96-4.43,1.64,1.12c71.32-5.54,75.78,1.63,1.01,1.63c74.77,0,69.47,0-1.2,0h-1.2
        h-1.2h-1.2h1.2h1.2h1.2h1.2h-1.2h-1.2h-1.2h-1.2h1.2h1.2h1.2h1.2h-1.2h-1.2h-1.2h-1.2c58.38,0,61.73,7.9,0.76,1.79
        c60.97,6.11,66.47,12.88,1.25,1.54c65.22,11.34,70.64,18.18,1.23,1.55c69.41,16.63,71.63,24.75,0.51,1.84
        c71.13,22.9,64.6,28.3-1.48,1.22c66.08,27.07,57.66,29.5-1.91,0.55c59.57,28.95,51.08,31.17-1.93,0.5
        c53.01,30.66,45.55,34.99-1.69,0.98c47.24,34.01,45.35,42.37-0.43,1.9c45.78,40.47,46.25,49.15,0.11,1.97
        c46.15,47.18,46.43,55.87,0.06,1.97c46.36,53.9,43.25,61.73-0.71,1.78c43.96,59.95,35.48,60.44-1.92,0.11
        c37.4,60.33,29.16,57.37-1.87-0.67c31.03,58.04,22.84,54.93-1.86-0.71c24.7,55.64,16.1,54.87-1.95-0.17
        c18.05,55.05,11.62,60.78-1.46,1.3c13.08,59.48,8.35,66.8-1.07,1.66c9.42,65.14,4.47,72.31-1.12,1.63
        C83.73,167.27,76.5,171.69,76.5,97.59z"/>
    </Svg>
  );
};

const ZipCodeSvg = ({
  width = 153,
  height = 151,
  scale = 1.0,
  color = '#000',
}): JSX.Element => {

  return (
    // @ts-expect-error - Svg props throws unnecessary TS Error but renders element
    // Known bug: https://github.com/diegomura/react-pdf/issues/1873 
    <Svg width={width * scale} height={height * scale}>
      <Path 
        stroke={color}
        strokeWidth={0.5 * scale}
        d="M76.5,97.59c0,74.11,0,68.85,0-1.19c0,70.04,0,64.79,0-1.19c0,65.98,0,60.73,0-1.19c0,61.92,0,56.67,0-1.19
        c0,57.86,0,63.12,0,1.19c0,61.92,0,67.18,0,1.19c0,65.98,0,71.24,0,1.19C76.5,166.44,76.5,171.69,76.5,97.59c0,74.11,0,68.85,0-1.19
        c0,70.04,0,64.79,0-1.19c0,65.98,0,60.73,0-1.19c0,61.92,0,56.67,0-1.19v1.19c0,61.92,0,67.18,0,1.19c0,65.98,0,71.24,0,1.19
        C76.5,166.44,76.5,171.69,76.5,97.59c0,74.11,0,68.85,0-1.19c0,70.04,0,64.79,0-1.19c0,65.98,0,60.73,0-1.19c0,61.92,0,56.67,0-1.19
        c0,57.86-7.97,61.18-1.81,0.75c-6.16,60.43-12.99,65.88-1.55,1.24c-11.44,64.65-18.34,70.01-1.57,1.22
        c-16.78,68.79-24.97,71-1.86,0.5c-23.11,70.5-28.55,64.03-1.23-1.47c-27.32,65.5-29.77,57.15-0.56-1.9
        c-29.21,59.04-31.44,50.63-0.51-1.91c-30.94,52.54-35.3,45.14-0.99-1.68c-34.31,46.82-42.74,44.95-1.91-0.43
        c-40.83,45.37-49.59,45.84-1.99,0.11c-47.6,45.74-56.37,46.02-1.99,0.06c-54.38,45.95-62.28,42.86-1.79-0.7
        c-60.49,43.57-60.98,35.17-0.11-1.91c-60.87,37.07-57.89,28.9,0.68-1.85c-58.56,30.76-55.42,22.64,0.71-1.84
        c-56.14,24.48-55.36,15.95,0.18-1.94C4.65,98.97-1.13,92.6,58.88,79.63c-60.01,12.97-67.4,8.28-1.68-1.06
        c-65.72,9.34-72.96,4.43-1.64-1.12c-71.32,5.54-75.78-1.63-1.01-1.63h1.2h1.2h1.2h1.2h-1.2h-1.2h-1.2h-1.2h1.2h1.2h1.2h1.2h-1.2
        h-1.2h-1.2h-1.2h1.2h1.2h1.2c-62.48,0-57.18,0,1.2,0c-58.38,0-61.73-7.9-0.76-1.79c-60.97-6.11-66.47-12.88-1.25-1.54
        c-65.22-11.34-70.64-18.18-1.23-1.55c-69.41-16.63-71.63-24.75-0.5-1.84c-71.13-22.9-64.6-28.3,1.48-1.22
        c-66.08-27.07-57.66-29.5,1.91-0.55c-59.57-28.95-51.08-31.17,1.93-0.5c-53.01-30.66-45.55-34.99,1.69-0.98
        c-47.24-34.01-45.35-42.37,0.43-1.9c-45.78-40.47-46.25-49.15-0.11-1.97C16.8,14.79,16.52,6.1,62.89,60
        C16.52,6.1,19.64-1.73,63.59,58.22C19.64-1.73,28.11-2.22,65.52,58.11c-37.4-60.33-29.16-57.37,1.87,0.67
        C36.36,0.74,44.55,3.85,69.25,59.49c-24.7-55.64-16.1-54.87,1.95,0.17c-18.05-55.05-11.62-60.77,1.46-1.3
        c-13.08-59.47-8.35-66.8,1.07-1.66c-9.42-65.14-4.47-72.31,1.12-1.63c-5.59-70.68,1.64-75.11,1.64-1c0-74.11,0-68.85,0,1.19
        c0-70.04,0-64.79,0,1.19c0-65.99,0-60.73,0,1.19c0-61.92,0-56.67,0,1.19c0-57.86,0-63.11,0-1.19c0-61.92,0-67.18,0-1.19
        c0-65.99,0-71.24,0-1.19c0-70.04,0-75.3,0-1.19c0-74.11,0-68.85,0,1.19c0-70.04,0-64.79,0,1.19c0-65.99,0-60.73,0,1.19
        c0-61.92,0-56.67,0,1.19v-1.19c0-61.92,0-67.18,0-1.19c0-65.99,0-71.24,0-1.19c0-70.04,0-75.3,0-1.19c0-74.11,0-68.85,0,1.19
        c0-70.04,0-64.79,0,1.19c0-65.99,0-60.73,0,1.19c0-61.92,0-56.67,0,1.19c0-57.86,7.97-61.18,1.81-0.75
        C84.47-2.35,91.3-7.8,79.86,56.84C91.3-7.8,98.2-13.17,81.43,55.62c16.78-68.79,24.97-71,1.86-0.5c23.11-70.5,28.55-64.03,1.23,1.47
        c27.32-65.5,29.77-57.15,0.56,1.9c29.21-59.04,31.44-50.63,0.51,1.91c30.94-52.54,35.3-45.14,0.99,1.68
        c34.31-46.82,42.75-44.95,1.91,0.42c40.83-45.37,49.59-45.84,1.99-0.11c47.6-45.74,56.37-46.01,1.99-0.06
        c54.38-45.95,62.28-42.86,1.79,0.7c60.49-43.57,60.98-35.17,0.11,1.91c60.87-37.07,57.89-28.9-0.68,1.85
        c58.56-30.76,55.42-22.64-0.71,1.84c56.14-24.48,55.37-15.95-0.18,1.94c55.54-17.89,61.32-11.52,1.31,1.45
        c60.01-12.97,67.4-8.28,1.68,1.06c65.72-9.34,72.96-4.43,1.64,1.12c71.32-5.54,75.78,1.63,1.01,1.63c74.77,0,69.47,0-1.2,0h-1.2
        h-1.2h-1.2h1.2h1.2h1.2h1.2h-1.2h-1.2h-1.2h-1.2h1.2h1.2h1.2h1.2h-1.2h-1.2h-1.2h-1.2c58.38,0,61.73,7.9,0.76,1.79
        c60.97,6.11,66.47,12.88,1.25,1.54c65.22,11.34,70.64,18.18,1.23,1.55c69.41,16.63,71.63,24.75,0.51,1.84
        c71.13,22.9,64.6,28.3-1.48,1.22c66.08,27.07,57.66,29.5-1.91,0.55c59.57,28.95,51.08,31.17-1.93,0.5
        c53.01,30.66,45.55,34.99-1.69,0.98c47.24,34.01,45.35,42.37-0.43,1.9c45.78,40.47,46.25,49.15,0.11,1.97
        c46.15,47.18,46.43,55.87,0.06,1.97c46.36,53.9,43.25,61.73-0.71,1.78c43.96,59.95,35.48,60.44-1.92,0.11
        c37.4,60.33,29.16,57.37-1.87-0.67c31.03,58.04,22.84,54.93-1.86-0.71c24.7,55.64,16.1,54.87-1.95-0.17
        c18.05,55.05,11.62,60.78-1.46,1.3c13.08,59.48,8.35,66.8-1.07,1.66c9.42,65.14,4.47,72.31-1.12,1.63
        C83.73,167.27,76.5,171.69,76.5,97.59z"/>

      <Path
        fill="#FFF"
        d="M73.7,32.4c-24.2,2.12-42.1,23.45-39.98,47.65l0.44,5.02c2.12,24.2,23.45,42.1,47.65,39.98c24.2-2.12,42.1-23.45,39.98-47.65l-0.44-5.02C119.23,48.19,97.9,30.29,73.7,32.4"
          />
    </Svg>
  );
};

export default ZipCodeSvg;
